<template>
    <video ref="videoPlayer" :class="playerClass" class="video-js" controls preload="auto">
        <source v-for="(source,i) in sources" :src="source.src+'#t=0.001'" :type="source.type" :key="i" />
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a
            web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">
                supports HTML5 video
            </a>
        </p>
    </video>
</template>

<script>
    import videojs from 'video.js';
    require('videojs-seek-buttons');

    import {
        ref,
        onMounted,
        onBeforeUnmount,
        reactive,
    } from 'vue';

    import videoCreatePoster from '@/helpers/video/createPoster';

    export default {
        name: "VideoJs",
        components: {

        },
        emits: ['onPlayerReady'],
        props: {
            options: {
                type: Object,
                default () {
                    return {};
                }
            },
            sources: {
                type: Array,
                default () {
                    return [];
                }
            }
        },
        setup(props, {
            emit
        }) {
            let player = null;
            const videoPlayer = ref(null);
            const playerClass = props.options.class ? props.options.class : '';

            onMounted(() => {

                let options = reactive(props.options)
                if (props.sources[0].src.match(/(blob:)/i)) {
                    options.sources = props.sources
                }

                const initPlayer = () => {
                    player = videojs(videoPlayer.value, options)
                    player.ready(function () {
                        setTimeout(() => {
                            emit('onPlayerReady')
                        }, 500);
                    });
                }

                if (!props.poster) {
                    const setPoster = (posterUrl) => {
                            options.poster = posterUrl;
                            initPlayer()
                        }
                        (async () => {
                            try {
                                await videoCreatePoster(props.sources[0].src, 0.01, setPoster)
                            } catch (error) {
                                console.log(error);
                            }
                        })();
                } else {
                    initPlayer()
                }
            })

            onBeforeUnmount(() => {
                if (player) {
                    player.dispose()
                }
            })

            return {
                videoPlayer,
                playerClass,
            }
        }
    }
</script>